import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  flex: "0 0 auto",
  width: "100%",
  padding: "22px 12px 16px 12px",
};

const header: CSSProperties = {
  marginBottom: 15,
};

const event: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginTop: "20px 0 15px 0",
};

const title: CSSProperties = {
  color: greys.standard,
  fontSize: 14,
  fontWeight: "bold",
  lineHeight: "17px",
};

const date: CSSProperties = {
  color: greys.standard,
  fontSize: 13,
  lineHeight: "15px",
};

const orangeBar: CSSProperties = {
  width: 3,
  height: 36,
  borderRadius: 5,
  backgroundColor: colors.peach.darker,
  marginRight: 15,
  marginLeft: 6,
};

const painContainer: CSSProperties = {
  marginTop: 6,
};

const warning: CSSProperties = {
  marginTop: 5,
  fontSize: 13,
  lineHeight: 1.75,
  color: colors.peach.darker,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const warningIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 6,
    display: "flex",
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: colors.peach.darker,
};

const button: CSSProperties = {
  marginTop: "auto",
  boxShadow: "none",
};

export const buttonIcon = {
  style: {
    marginRight: 7,
  } as CSSProperties,
  htmlColor: greys.white,
};

export const styles = {
  container,
  header,
  event,
  title,
  date,
  orangeBar,
  painContainer,
  warning,
  button,
};
